import { defineStore } from 'pinia'

interface State {
  siteMeta: {
    metaType: string
    metaUrl: string
    metaSiteName: string
  }
  isWindowLoaded: boolean
  use3rdPartyCookieManagement: boolean
  isInspectorMode: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  pageEntrySys?: any
}

export const useGlobalStore = defineStore('main', {
  state: (): State => ({
    siteMeta: {
      metaType: 'website',
      metaUrl: 'https://wpn.wizards.com/',
      metaSiteName: 'Wizards Play Network',
    },
    isWindowLoaded: false,
    use3rdPartyCookieManagement: false,
    isInspectorMode: false,
  }),
})
